import { log } from 'log';
import { useCallback } from 'react';

import * as Types from '../types';

export const useXpointRequestPacket = ({
    sdk,
    license,
    transactionID
}: {
    sdk: Types.XPointSDKInstance | null;
    license: any;
    transactionID: string | null;
}) => {
    return useCallback(async () => {
        if (!sdk) {
            return;
        }

        log('gcReq', {
            transactionID,
            license
        });
    }, [
        sdk,
        license,
        transactionID
    ]);
};
